<div class="dropdown">
  <button
    class="btn btn-outline-secondary btn-sm dropdown-toggle"
    type="button"
    data-toggle="dropdown"
    gtagEvent
    trackOn="click"
    action="Optimize_Menu"
    category="Route"
    [params]="{ event_label: 'Optimize Menu clicked' }"
  >
    Optimize
  </button>
  <div class="dropdown-menu dropdown-menu-right">
    <button
      class="dropdown-item small"
      (click)="optimizeStops(optimizationEnum.OPTIMIZE_ALL_STOPS)"
      [disabled]="route.stops.length < 3"
      gtagEvent
      trackOn="click"
      action="Optimize_Stop_Order(Keep Destination)"
      category="Route"
      [params]="{ event_label: 'Optimize Stop Order clicked' }"
    >
      Optimize Stop Order
    </button>
    <button
      class="dropdown-item small"
      (click)="optimizeStops(optimizationEnum.OPTIMIZE_INTERMEDIATE_STOPS)"
      [disabled]="route.stops.length < 4"
      gtagEvent
      trackOn="click"
      action="Optimize_Stop_Order"
      category="Route"
      [params]="{
        event_label: 'Optimize Stop Order(Keep Destination) clicked'
      }"
    >
      Optimize Stop Order (Keep Destination)
    </button>
  </div>
</div>
